import React from "react";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from "react-select-new";

export default class ReportAudits extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            notice: "",
            success: "",
            type: "events",
            period1Disabled: false
        };
    }

    handleDateChange = (name, date) => {
        this.setState({
            [name]: date,
            period1Disabled: false,
            notice: "",
            success: ""
        });
    };

    downloadReport = (e) => {
        e.preventDefault();
        let notice = "";
        let success = "";
        let url = null;

        if (!this.state.startDate || !this.state.endDate) {
            this.setState({
                "notice": "Zowel begin- als einddatum is vereist voor periode 1",
                "success": "",
            });
            return;
        }

        if (this.state.type === "events") {
            url = `/v1/reports/auditor-events/?date_after=${moment(this.state.startDate).format("YYYY-MM-DD")}&date_before=${moment(this.state.endDate).format(
                "YYYY-MM-DD"
            )}`;
        } else if (this.state.type === "audits") {
            url = `/v1/reports/audits/?date_after=${moment(this.state.startDate).format("YYYY-MM-DD")}&date_before=${moment(this.state.endDate).format(
                "YYYY-MM-DD"
            )}`;
        } else {
            throw new Error("No such report type: " + this.state.type);
        }

        if (url) {
            axios
                .get(url)
                .then((response) => {
                    let message = "Het rapport wordt gegenereerd en per e-mail naar je verzonden.";
                    if (response.data && response.data.message) {
                        message = response.data.message;
                    }

                    this.setState({
                        period1Disabled: true,
                        success: message
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        this.setState({
            notice,
            success
        });
    };

    render() {
        let notice = "";
        if (this.state.notice !== "") {
            notice = <div className="alert alert-warning">{this.state.notice}</div>;
        }
        let success = "";
        if (this.state.success !== "") {
            success = <div className="alert alert-success">{this.state.success}</div>;
        }

        const options = [
            { value: "events", label: "Controle planning" },
            { value: "audits", label: "Controles" },
        ];

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <h2>Controles</h2>
                        {notice}
                        {success}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mb-2">
                        <Select
                            className="react-select-new"
                            classNamePrefix="react-select"
                            name="type"
                            onChange={({value}) => {
                                this.setState({
                                    type: value,
                                    period1Disabled: false
                                });
                            }}
                            value={options.find(option => option.value === this.state.type)}
                            options={options}
                            isClearable={false}
                            placeholder="Selecteer een rapporttype"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <DatePicker
                            name="startDate"
                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                            onChange={(value) => this.handleDateChange("startDate", value)}
                            onChangeRaw={(event) => {
                                let value = event.target.value.split("-").join("");
                                let newDate = value.substring(0, 2);
                                if (value.length >= 3) {
                                    newDate += "-" + value.substring(2, 4);
                                }
                                if (value.length >= 5) {
                                    let checkYear = value.substring(4, 8);
                                    if (checkYear.length === 2 && checkYear !== "19" && checkYear !== "20") {
                                        newDate += "-19" + value.substring(4, 8);
                                    } else {
                                        newDate += "-" + value.substring(4, 8);
                                    }
                                }
                                event.target.value = newDate;
                            }}
                            className="form-control"
                            required={false}
                            placeholderText="Datum vanaf (dd-mm-yyyy)"
                            selected={this.state.startDate}
                            autoComplete="off"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>
                    <div className="col-4">
                        <DatePicker
                            name="endDate"
                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                            onChange={(value) => this.handleDateChange("endDate", value)}
                            onChangeRaw={(event) => {
                                let value = event.target.value.split("-").join("");
                                let newDate = value.substring(0, 2);
                                if (value.length >= 3) {
                                    newDate += "-" + value.substring(2, 4);
                                }
                                if (value.length >= 5) {
                                    let checkYear = value.substring(4, 8);
                                    if (checkYear.length === 2 && checkYear !== "19" && checkYear !== "20") {
                                        newDate += "-19" + value.substring(4, 8);
                                    } else {
                                        newDate += "-" + value.substring(4, 8);
                                    }
                                }
                                event.target.value = newDate;
                            }}
                            className="form-control"
                            required={false}
                            placeholderText="Datum tot en met (dd-mm-yyyy)"
                            selected={this.state.endDate}
                            autoComplete="off"
                            minDate={moment(this.state.startDate)}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>

                    <div className="col-4">
                        <button className="btn btn-secondary" onClick={(e) => this.downloadReport(e, "audits")} disabled={this.state.period1Disabled}>
                            Genereer rapport
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
